import { observer } from 'mobx-react-lite'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Key, Wrench } from 'lucide-react'

const ApiKeyList = observer(() => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">APIキー管理</h1>
        <p className="text-muted-foreground">
          外部サービスとの連携に使用するAPIキーを管理します
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Wrench className="h-5 w-5" />
            準備中
          </CardTitle>
          <CardDescription>
            この機能は現在開発中です
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex flex-col items-center justify-center py-12 text-center">
              <div className="rounded-full bg-muted p-4 mb-4">
                <Key className="h-12 w-12 text-muted-foreground" />
              </div>
              <h3 className="text-lg font-semibold mb-2">APIキー管理機能</h3>
              <p className="text-sm text-muted-foreground max-w-md">
                APIキーの作成、無効化、権限管理などの機能を準備しています。
                近日中に公開予定です。
              </p>
            </div>

            <div className="border rounded-lg p-4 bg-muted/50">
              <h4 className="text-sm font-medium mb-2">予定されている機能：</h4>
              <ul className="text-sm text-muted-foreground space-y-1">
                <li>• APIキーの生成と管理</li>
                <li>• アクセス権限の設定</li>
                <li>• 使用状況の確認</li>
                <li>• APIキーの有効期限設定</li>
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
})

export default ApiKeyList